<div class="row justify-content-center">
    
    <div class="col-lg-8">
        <div class="card">
            <div class="card-header bg-info">
                <h4 class="m-b-0 text-white">Factores Barsit</h4>
            </div>
            <div class="card-body">
                
                <h3 class="card-title">Listado de valores</h3>
                <hr>
                    <div *ngFor="let factor of factors" class="form-body">
                            
                        <div class="col-md-12 text-center">
                            <h2 *ngIf="factor.name=='informacion'">Valor: Información</h2>
                            <h2 *ngIf="factor.name=='razonamientoVerbal'">Valor: Razonamiento verbal</h2>
                            <h2 *ngIf="factor.name=='comprensionDeVocabulario'">Valor: Comprensión de vocabulario</h2>
                            <h2 *ngIf="factor.name=='razonamientoLogico'">Valor: Razonamiento Lógico</h2>
                            <h2 *ngIf="factor.name=='razonamientoNumerico'">Valor: Razonamiento Numérico</h2>

                        </div>

                        <div class="row p-t-20">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <h3>Muy baja puntuación</h3>
                                    <p>{{factor.veryLowDesc}}</p>
                                </div>
                            </div>

                        </div>

                        <div class="row p-t-20">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <h3>Baja puntuación</h3>
                                    <p>{{factor.lowDesc}}</p>
                                </div>
                            </div>

                        </div>
                        <div class="row p-t-20">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <h3>Puntuación media</h3>
                                    <p>{{factor.midDesc}}</p>
                                </div>
                            </div>
                        </div>

                        <div class="row p-t-20">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <h3>Alta puntuación</h3>
                                    <p>{{factor.highDesc}}</p>
                                </div>
                            </div>

                        </div><div class="row p-t-20">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <h3>Muy alta puntuación</h3>
                                    <p>{{factor.veryHighDesc}}</p>
                                </div>
                            </div>

                        </div>
                        <button type="button" class="btn waves-effect waves-light btn-danger"(click)="handleDelete(factor)">Borrar</button>

                        <hr>
                    </div>
                    
                
            </div>
        </div>
    </div>
</div>